module.exports = function(contract, args, deployer) {
  return async function() {
    deployer.logger.log("Creating new instance of " + contract.contract_name);
    // Evaluate any arguments if they're promises
    const newArgs = await Promise.all(args);
    return contract.new.apply(contract, args);
  };
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-deployer/src/actions/new.js
// module id = 2765
// module chunks = 0 1